module.exports = __webpack_public_path__ + "img/_ABS9815.4ca5a7d1.jpg";